<template>
  <div>
    <confirm
      v-model="showBox"
      title="激活"
      @on-cancel="onCancel"
      @on-confirm="onConfirm"
    >
      <div class="inputBox flex">
        <input
          class="flex1"
          placeholder="请输入验证码"
          v-model="code"
          style="border-right: 1px solid rgba(232,232,232,1);"
        />
        <div
          class="codeButton"
          @click="getCode"
          :class="isDisable == true ? 'disabled' : ''"
        >
          {{ getMobileCodeText() }}
        </div>
      </div>
    </confirm>

    <confirm
      v-model="show1"
      title="操作提示"
      confirm-text="前去完善"
      @on-cancel="onCancel1"
      @on-confirm="onConfirm1"
    >
      <p style="text-align:center;">请先完善个人信息</p>
    </confirm>
  </div>
</template>

<script>
import { Confirm } from "vux";
import { codeFetch, bankMemberActive } from "../../api/client";
import { getType } from "../../utils/auth";
import { getClientDetail } from "@/api/client";
import { getAdminUserDetail } from "@/api/trader";
export default {
  name: "active",
  components: {
    Confirm
  },
  data() {
    return {
      show1: false,
      showBox: false,
      code: "",
      isDisable: false,
      wait_timer: false,
      registerId: ""
    };
  },
  created() {},
  methods: {
    getCode() {
      let that = this;
      that.wait_timer = 59;
      that.isDisable = true;
      let timer_interval = setInterval(function() {
        if (that.wait_timer > 0) {
          that.wait_timer--;
        } else {
          that.isDisable = false;
          clearInterval(timer_interval);
        }
      }, 1000);
      codeFetch()
        .then(res => {
          this.registerId = res.registerId;
        })
        .catch(err => {
          this.wait_timer = false;
          this.isDisable = false;
          this.$showError(err);
          this.show1 = true;
          this.showBox = false;
        });
    },
    getMobileCodeText() {
      if (this.wait_timer > 0) {
        return this.wait_timer + "s后获取";
      }
      if (this.wait_timer === 0) {
        return "重新获取";
      }
      if (this.wait_timer === false) {
        return "获取验证码";
      }
    },
    onCancel1() {
      this.show1 = false;
    },
    onConfirm1() {
      this.show1 = false;
      this.$router.push("/user/myInfoChange");
    },
    onCancel() {
      // this.$emit("childFn", false);
    },
    onConfirm() {
      bankMemberActive({
        code: this.code,
        registerId: this.registerId
      })
        .then(() => {
          if (getType() === 1) {
            getClientDetail().then(res => {
              this.$store.commit("saveUserInfo", res);
            });
          } else {
            getAdminUserDetail().then(res => {
              this.$store.commit("saveUserInfo", res);
            });
          }
          // this.$emit("activeSuccess", false);
        })
        .catch(err => {
          // this.$emit("childFn", false);
          this.$showError(err);
        });
    }
  }
};
</script>

<style scoped>
.codeButton {
  width: 160px;
  color: #039df8;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  margin: 13px 0 13px 35px;
}
.disabled {
  pointer-events: none;
}
.inputBox {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.inputBox input {
  color: #999999;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  border: none;
  margin: 13px 0;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
</style>
